import React from 'react';
import { Box, Flex, Text, Divider, Container, Image, Link, useBreakpointValue } from '@chakra-ui/react';
import { FileX2Icon } from 'lucide-react';

const Footer = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const companyNames = [
    "Rashmi Metaliks Limited",
    "Rashmi Green Hydrogen Steel Private Limited",
    "Rashmi 6 Paradigm Limited",
    "Koove IOT Private Limited",
    "Koove Organic Chemicals Private Limited",
    "Reach Dredging Limited",
    "Rashmi Pipe",
    "Ravion Aviation Services Private Limited"
  ];

  const currentYear = new Date().getFullYear();

  return (
    <Box
      as="footer"
      w="100%"
      borderTop="1px solid"
      borderColor="gray.200"
      bg="white"
      py={{ base: 4, md: 5 }}
    >
      <Container maxW="1400px">
        <Flex direction="column" alignItems="center">
          {/* Group Companies */}
          <Box textAlign="center" mb={3}>
            <Text
              fontSize="xs"
              fontWeight="bold"
              color="gray.600"
              textTransform="uppercase"
              letterSpacing="0.5px"
              mb={2}
            >
              Group Companies
            </Text>

            <Flex
              direction={isMobile ? "column" : "row"}
              wrap="wrap"
              justifyContent="center"
              alignItems="center"
              gap={isMobile ? 1 : 4}
            >
              {companyNames.map((company, index) => (
                <Flex key={index} alignItems="center">
                  <Text
                    fontSize="xs"
                    color="gray.600"
                    _hover={{ color: "blue.500" }}
                  >
                    {company}
                  </Text>
                  {!isMobile && index < companyNames.length - 1 && (
                    <Box
                      w="4px"
                      h="4px"
                      borderRadius="full"
                      bg="gray.400"
                      mx={3}
                    />
                  )}
                </Flex>
              ))}
            </Flex>
          </Box>

          <Divider borderColor="gray.300" opacity={0.8} mb={3} />

          {/* Bottom section */}
          <Flex
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            direction={isMobile ? "column" : "row"}
            gap={isMobile ? 2 : 0}
          >
            <Flex alignItems="center">
              <Image
                src="/logo_black.png"
                alt="Logo"
                height="30px"
                mr={2}
                opacity={0.9}
              />
              <Text fontSize="xs" color="gray.500">
                © {currentYear} IT Self Service Portal
              </Text>
            </Flex>

            <Flex gap={3} alignItems="center">
              <Link fontSize="xs" color="gray.500" _hover={{ color: "blue.500" }}>
                Privacy Policy
              </Link>
              {!isMobile && (
                <Box w="4px" h="4px" borderRadius="full" bg="gray.400" />
              )}
              <Link fontSize="xs" color="gray.500" _hover={{ color: "blue.500" }}>
                Terms of Service
              </Link>
            </Flex>
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
};

export default Footer;
